import { createAsyncThunk } from "@reduxjs/toolkit"
import ApiServices from "../../services/api.service"
import { BASEURI, headers } from "../../utils/helper"

class UserSlice {
  constructor() {
    this.apiServices = new ApiServices()
  }

  // Enable user's status
  enableUser = createAsyncThunk(
    "update",
    async (data, thunkAPI) => {
      return this.apiServices.request(
        {
          method: "PUT",
          headers: headers(),
          data: { reason: data?.reason, },
          url: `${BASEURI}/admin/member/update/${data?.id}/enable`,
        },
        thunkAPI
      )
    }
  )

  // Disable user's status
  disableUser = createAsyncThunk(
    "update",
    async (data, thunkAPI) => {
      return this.apiServices.request(
        {
          method: "PUT",
          headers: headers(),
          data: { reason: data?.reason, },
          url: `${BASEURI}/admin/member/update/${data?.id}/disable`,
        },
        thunkAPI
      )
    }
  )
}

export default UserSlice